import { getUserData } from './api/getUserData';

const UserSystem = {
  namespaced: true,

  state: {
    isReady: false,
    isLoading: false,
    isTelegramSubscribeWidgetLast: false,

    user: {
      isAuthenticated: false,
      isPaid: false,
      name: '',
      username: null,
      avatar: `${require('@shared/images/user/default_avatar.webp')}`,
      subscription_end_date: null,
      telegram_days_left: null,
      telegram_subscription_end_date: null,
      cryptocloud_days_left: null,
      cryptocloud_subscription_end_date: null,
      has_cryptocloud_subscription: false,
      twitter: '',
      telegram: null,
      show_telegram: false,
      eth_address: '',
      show_eth_address: false,
      groups: null,
      description: '',
      email: '',
      email_verified: false,
      has_pon_subscription: false,
      has_telegram_subscription: false,
      cryptocloud_frozen_remaining_days: null,
    },

    menuScrollPosition: 0
  },

  actions: {
    // Получаем данные пользователя
    async toGetUserData({ commit }) {
      commit('toChangeLoadingStatus', true);
      try {
        const data = await getUserData();
        commit('setUserData', data);
        commit('toChangeReadyStatus', true);
      } catch (error) {
        console.error(`Ошибка при получении данных пользователя: ${error}`);
        // Здесь можно добавить уведомление для пользователя
      } finally {
        commit('toChangeLoadingStatus', false);
      }
    },

    // Логаут пользователя
    toLogout({ commit }) {
      commit('clearUserData');
      commit('toChangeAuthenticatedStatus', false);
    },
  },

  mutations: {
    //Положить данные пользователя в хранилище
    setUserData(state, userData) {
      const defaultAvatar = 'https://dropscapital.fra1.cdn.digitaloceanspaces.com/static/images/default_avatar.webp';
      state.user.name = userData.first_name ?? state.user.name;
      state.user.subscription_end_date = userData.subscription_end_date ?? state.user.subscription_end_date;
      state.user.username = userData.username ?? state.user.username;
      state.user.avatar = userData.avatar || defaultAvatar;
      state.user.date_joined = userData.date_joined ?? state.user.date_joined;
      state.user.email = userData.email ?? state.user.email;
      state.user.email_verified = userData.email_verified ?? state.user.email_verified;
      state.user.twitter = userData.twitter ?? state.user.twitter;
      state.user.telegram = userData.telegram ?? state.user.telegram;
      state.user.show_telegram = userData.show_telegram ?? state.user.show_telegram;
      state.user.eth_address = userData.eth_address ?? state.user.eth_address;
      state.user.show_eth_address = userData.show_eth_address ?? state.user.show_eth_address;
      state.user.groups = userData.groups || [];
      state.user.description = userData.description ?? state.user.description;
      state.user.telegram_days_left = userData.telegram_days_left ?? state.user.telegram_days_left;
      state.user.has_pon_subscription = userData.has_pon_subscription ?? state.user.has_pon_subscription;
      state.user.has_telegram_subscription = userData.has_telegram_subscription ?? state.user.has_telegram_subscription;
      state.user.telegram_subscription_end_date = userData.telegram_subscription_end_date ?? state.user.telegram_subscription_end_date;
      state.user.cryptocloud_subscription_end_date = userData.cryptocloud_subscription_end_date ?? state.user.cryptocloud_subscription_end_date;
      state.user.cryptocloud_days_left = userData.cryptocloud_days_left ?? state.user.cryptocloud_days_left;
      state.user.has_cryptocloud_subscription = userData.has_cryptocloud_subscription ?? state.user.has_cryptocloud_subscription;
      state.user.cryptocloud_frozen_remaining_days = userData.cryptocloud_frozen_remaining_days ?? state.user.cryptocloud_frozen_remaining_days;
    },

    // Очистить данные пользователя
    clearUserData(state) {
      state.isReady = false;
      state.isLoading = false;
      state.user = {
        isAuthenticated: false,
        isPaid: false,
        name: '',
        username: null,
        avatar: 'https://dropscapital.fra1.digitaloceanspaces.com/static/images/default_avatar.webp',
        twitter: '',
        telegram: null,
        show_telegram: false,
        subscription_end_date: null,
        telegram_subscription_end_date: null,
        eth_address: '',
        show_eth_address: false,
        groups: null,
        description: '',
        email: '',
        email_verified: false,
        cryptocloud_subscription_end_date: null,
        has_cryptocloud_subscription: null,
        telegram_days_left: null,
        cryptocloud_days_left: null,
        cryptocloud_frozen_remaining_days: null,
      };
    },

    // Переключить состояние загрузки данных
    toChangeLoadingStatus(state, status) {
      state.isLoading = status;
    },

    // Обозначить, готовы ли данные пользователя для выдачи
    toChangeReadyStatus(state, status) {
      state.isReady = status;
    },

    // Изменить статус авторизации пользователя
    toChangeAuthenticatedStatus(state, status) {
      state.user.isAuthenticated = status;
    },

    // Изменить статус оплачен/неоплачен аккаунт
    toChangePaidStatus(state, status) {
      state.user.isPaid = status;
    },

    // Установка позиции скролла в верхнем меню адаптива
    SET_SCROLL_POSITION(state, position) {
      state.menuScrollPosition = position;
    },

    SET_TELEGRAM_SUBSCRIBE_WIDGET_LAST(state, value) {
      state.isTelegramSubscribeWidgetLast = value;
    }
  },

  getters: {
    // Имеет ли доступ к закрытому контенту пользователь
    hasPaidAccess(state) {
      return state.user.isAuthenticated && (state.user.groups?.includes('AccountPaid') || state.user.has_telegram_subscription);
    },

    // Пользователь авторизован?
    isAuthenticated(state) {
      return state.user.isAuthenticated;
    },

    // Пользователь обладает правами модератора?
    hasModeratorPrivileges(state) {
      return (
        state.user.groups?.includes('Moderators') || state.user.groups?.includes('Editors')
      );
    },

    // Загрузка во время проверки юзера
    hasIsLoading(state) {
      return state.isLoading;
    },

    //Загрузка во время проверки юзера
    hasPon(state) {
      return state.user.has_pon_subscription;
    },

    // Пользователь имеет подписку на телеграм?
    hasTelegramSubscription(state) {
      return state.user.has_telegram_subscription;
    },

    hasTelegramAccount(state){
      return state.user.telegram;
    },

    hasLegendAccess(state) {
      return state.user.isAuthenticated && state.user.groups?.includes('AccountLegend');
    }
  },
};

export default UserSystem;
